import React from "react";
import CPScheduleAndPrice from "./components/CPScheduleAndPrice";

function CPScheduleAndPricingMain({ setCurrentTab, productDetail, productId }) {
  return (
    <CPScheduleAndPrice
      setCurrentTab={setCurrentTab}
      productDetail={productDetail}
      productId={productId}
    />
  );
}

export default CPScheduleAndPricingMain;
